import {EDIT_MULTIPLE_ERRORS_SUCCESS} from "../../../reducers/editErrorReducer";


export const editMultipleErrorsSuccess = (errors) =>{
    return {
        type: EDIT_MULTIPLE_ERRORS_SUCCESS,
        payload: {errors}
    }
}